import { Card, CardContent, Container, Grid, MenuItem, TextField, Typography } from "@material-ui/core";
import { useKiosk } from "application/contexts/kiosk/KioskContext";
import { useUi } from "application/contexts/ui/UIContext";
import BottomModal from "components/bottomModal/BottomModal";
import { PassKeyboard } from "components/passKeyboard/PassKeyboard";
import enviroment from "corss-cutting/enviroment";
import { getDeviceInfo } from "modules/reactNativeBridge/ReactNativeBridge";
import { useEvents } from "modules/events/presentation/UseEvents";
import React, { useCallback, useEffect, useState } from "react";
import { useAdmin } from "../../../application/contexts/admin/adminContext";
import { CefSharpConfigRepository } from "Infrastructure/services/cefSharpService/local/CefSharpConfigRepository";
import { isReactNative } from "utils/constants";
import styles from "./AuthOperator.module.scss"

export const AuthOperator = () => {
  const { operators, setOperator } = useAdmin();
  const { toast } = useUi();
  const { kiosk } = useKiosk();
  const { events } = useEvents(kiosk?.localId, Boolean(kiosk?.worksWithEvents));
  const selectedEventName = events.find((event) => event.id === kiosk?.eventId)?.name;

  const [operatorId, setoperatorId] = useState<string | null>(null);
  const [deviceSerial, setDeviceSerial] = useState<string>("");
  const [appVersion, setAppVersion] = useState<string>("");
  const [deviceMac, setDeviceMac] = useState<string>("");

  // Windows: o MAC (IMEI) vem direto da casca, sem depender da API, porque é com ele
  // que um equipamento novo é cadastrado. No Android o equivalente é o serial, abaixo.
  useEffect(() => {
    if (isReactNative) return;

    Promise.resolve(CefSharpConfigRepository().getDeviceIdAsync?.())
      .then((mac) => mac && setDeviceMac(mac))
      .catch((error) => console.error("Erro ao obter o MAC do equipamento:", error));
  }, []);

  useEffect(() => {
    const fetchDeviceInfo = async () => {
      try {
        if (!getDeviceInfo) return;
        const deviceInfo = await getDeviceInfo();
        if (deviceInfo) {
          if (deviceInfo.serialNumber && typeof deviceInfo.serialNumber === 'string') {
            setDeviceSerial(deviceInfo.serialNumber);
          }
          if (deviceInfo.appVersion && typeof deviceInfo.appVersion === 'string') {
            setAppVersion(deviceInfo.appVersion);
          }
        }
      } catch (error) {
        console.error("Erro ao obter informações do dispositivo:", error);
      }
    };
    fetchDeviceInfo();
  }, []);

  const onPressLogin = useCallback(
    (valid: boolean) => {
      if (valid && operatorId) {
        setOperator(operatorId);
      } else {
        toast("Senha incorreta", "error");
      }
    },
    [setOperator, operatorId, toast]
  );

  return (
    <Container
      style={{
        padding: "16px 32px 24px",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 8,
      }}
    >
      <Grid spacing={2} container>
        <Card variant="outlined" className={styles.infoCard}>
          <CardContent className={styles.infoCardContent}>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">PDV</Typography>
              <Typography variant="body1">{kiosk?.profilerNamePDV ?? "—"}</Typography>
            </div>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">Patrimônio</Typography>
              <Typography variant="body1">{kiosk?.kioskName ?? "—"}</Typography>
            </div>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">Versão CefSharp</Typography>
              <Typography variant="body1">{kiosk?.cefsharpVersion ?? "—"}</Typography>
            </div>
            <div className={styles.infoRow}>
              <Typography variant="body2" color="textSecondary">Versão</Typography>
              <Typography variant="body1">{kiosk?.reactVersionTotem ?? "—"}</Typography>
            </div>
            {kiosk?.eventId && (
              <div className={styles.infoRow}>
                <Typography variant="body2" color="textSecondary">Evento</Typography>
                <Typography variant="body1">{selectedEventName ?? kiosk.eventId}</Typography>
              </div>
            )}
          </CardContent>
        </Card>

        <TextField
          fullWidth
          value={operatorId ?? ""}
          select
          label="Selecione o operador"
          onChange={(e) => setoperatorId(e.target.value)}
          name={"operator"}
          variant="outlined"
          className={styles.select}
        >
          {operators.length ? (
            operators.map((operator) => (
              <MenuItem key={operator.id} value={operator.id}>
                {operator.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="">Aguarde...</MenuItem>
          )}
        </TextField>

        <BottomModal
          showModal={!!operatorId}
          onClickClose={() => setoperatorId(null)}
        >
          <div className={"drawer-paymentCashless"}>
            <h2>{`${
              operators.find((it) => it.id === operatorId)?.name ?? "Operador"
            }, entre com sua senha.`}</h2>
            <PassKeyboard
              onValidate={onPressLogin}
              password={
                operators.find((operator) => operator.id === operatorId)
                  ?.password ?? "xxx"
              }
            />
          </div>
        </BottomModal>
      </Grid>
      <div className={styles.version}>
        {kiosk?.localName && <span>{kiosk.localName}</span>}
        {kiosk?.kioskName && <span>{kiosk.kioskName}</span>}
        <span>{enviroment.appVersion}</span>
      </div>
      {(deviceSerial || deviceMac || appVersion) && (
        <div className={styles.serial}>
          {deviceSerial && `Serial: ${deviceSerial}`}
          {deviceMac && `IMEI (MAC): ${deviceMac}`}
          {(deviceSerial || deviceMac) && appVersion && " - "}
          {appVersion && `App Version: v${appVersion}`}
        </div>
      )}
    </Container>
  );
};
